<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <v-layout row v-if="errors">
        <v-flex>
          <Alert @dismissed="onDismissed" :text="errors"></Alert>
        </v-flex>
      </v-layout>
      <div>
        <PageTitleWithSearch
          :title="'Branches'"
          :btnName="'Create New Branch'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/branches/create'"
          :btnPermission="'branch.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />
        <DataTableWithPagination
          :headers="headers"
          :items="branchList"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item}">
            <tr :key="item.id">
              <td class="text-left">{{ item.code }}</td>
              <td class="text-left">{{ item.name }}</td>
              <td class="text-left">{{ item.status }}</td>
              <td class="text-center">
                <v-btn
                  v-if="hasPermission('branch.edit')"
                  class="ma-1"
                  color="#FFE0B2"
                  :to="'/branches/edit/' + item.id"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  disabled
                  class="ma-1"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-if="hasPermission('branch.delete')"
                  color="#FFCDD2"
                  fab
                  x-small
                  style="box-shadow: none;"
                  @click.stop="deleteBranch(item.uuid)"
                >
                  <v-icon small color="#FF9800">mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  disabled
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </DataTableWithPagination>
      </div>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @closeSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import { BranchService } from "@/services/branch-service.js";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Snackbars from "@/components/shared/Snackbars";
import { checkError } from "@/config/errors.js";
import Alert from "@/components/shared/Alert.vue";

export default {
  name: "BranchListTable",
  components: {
    PageTitleWithSearch,
    DataTableWithPagination,
    Alert,
    Snackbars,
  },
  data() {
    return {
      loading: false,
      search: "",
      branchList: [],
      headers: [
        { text: "Branch Code", align: "start", value: "code" },
        { text: "Branch Name", align: "start", value: "name" },
        { text: "Status", align: "start", value: "status" },
        { text: "Actions", align: "center", value: "actions" },
      ],
      snackbar: false,
      successMsg: "",
      errors: null,
      page: 1,
      total: 0,
      totalBranches: 0,
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  created() {
    this.fetchBranchList();
  },
  watch: {
    search(newSearch) {
      this.fetchBranchList(newSearch);
    },
    page() {
      this.fetchBranchList(this.search);
    },
  },
  methods: {
    async fetchBranchList(search = "") {
      this.loading = true;
      try {
        const response = await BranchService.getBranches(search, this.page);
        this.branchList = response.data.data || [];
        this.total = response.data?.meta?.last_page || 0;
        this.totalBranches = response.data?.meta?.total || 0;
      } catch (error) {
        this.branchList = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    searchChange(event) {
      this.search = event;
    },
    async deleteBranch(uuid) {
      this.loading = true;
      try {
        await BranchService.deleteBranch(uuid);
        this.successMsg = "Branch deleted successfully.";
        this.snackbar = true;
        this.fetchBranchList();
      } catch (error) {
        this.loading = false;
        let data = error.response?.data?.message || "Unknown error";
        let errorOutput = checkError.errorFormatting(data);

        let errorsArray = [];
        if (Array.isArray(errorOutput)) {
          errorsArray = errorOutput.filter((e) => !!e && e.trim());
          if (errorsArray.length === 0) errorsArray = [data];
        } else if (errorOutput && errorOutput.trim()) {
          errorsArray = [errorOutput];
        } else {
          errorsArray = [data];
        }
        this.errors = errorsArray;
      }
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    onDismissed() {
      this.errors = null;
    },
  },
};
</script>

<style scoped>
.dark-row {
  background-color: #fafafa;
  color: rgb(0, 0, 0);
}
.light-row {
  background-color: #ffffff;
}
.custom-row:hover {
  background-color: #e8e8e8;
}
.custom-row {
  height: 60px;
  border: none;
}
</style>
